import { render, staticRenderFns } from "./CardsReport.vue?vue&type=template&id=cdf8d506"
import script from "./CardsReport.vue?vue&type=script&lang=js"
export * from "./CardsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports